// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"9ffdc2a5","212":"dfd4baab"}[chunkId] + ".chunk.js";
};